:root {
  color: #103449;
  background: #ffffff;
  font-family: "Inter", "Segoe UI", Arial, sans-serif;
  line-height: 1.45;
}

/* cod5 final polish: reduce artificial vertical voids and keep content grouped */
.emptyWordpressGap {
  min-height: clamp(520px, 55vw, 920px);
}

.aboutPage,
.commitmentPage,
.contactPage,
.articlePage {
  min-height: auto;
}

.production,
.categoryCards,
.internalCards,
.newsGrid {
  margin-bottom: clamp(42px, 6vw, 72px);
}

.aboutPage,
.commitmentPage,
.contactPage {
  gap: clamp(28px, 5vw, 48px);
}

.categoryCards article,
.newsletterForm,
.contactPage form,
.articleAside,
.postCard {
  box-shadow: 0 18px 48px rgba(8, 39, 55, 0.10);
}

footer {
  padding-top: clamp(62px, 7vw, 88px);
}

@media (max-width: 760px) {
  .emptyWordpressGap {
    min-height: 720px;
  }

  .aboutPage,
  .commitmentPage,
  .contactPage,
  .articlePage {
    min-height: auto;
  }

  .categoryCards {
    margin-bottom: 52px;
  }
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
}

a {
  color: inherit;
  text-decoration: none;
}

img {
  display: block;
  max-width: 100%;
}

.siteHeader {
  background: #ffffff;
}

.topLine {
  height: 26px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  padding: 0 max(56px, calc((100vw - 1200px) / 2));
  background: #0b3447;
  color: #ffffff;
  font-size: 0.78rem;
}

.navBar {
  height: 78px;
  width: min(1200px, calc(100% - 64px));
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}

.brand img {
  width: 155px;
}

nav {
  display: flex;
  align-items: center;
  gap: 31px;
  font-size: 0.82rem;
  font-weight: 800;
}

.budget,
.button,
button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 999px;
  background: #ec1236;
  color: #ffffff;
  font-size: 0.78rem;
  font-weight: 900;
  text-transform: uppercase;
}

.budget {
  min-height: 38px;
  padding: 0 22px;
}

.hero {
  min-height: 565px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 7em max(80px, calc((100vw - 1200px) / 2)) 14em;
  color: #ffffff;
}

.hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: linear-gradient(90deg, rgba(6, 31, 44, 0.50), rgba(6, 31, 44, 0.24)), url("/assets/wp-original/nelore-banner-capa1-scaled.jpg");
  background-position: center;
  background-size: cover;
  animation: nobresHero 15s infinite;
  transform: scale(1.02);
}

.hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(7, 38, 55, 0.34);
}

.heroText {
  position: relative;
  z-index: 2;
}

.heroText { max-width: 540px; }

@keyframes nobresHero {
  0%, 30% { background-image: linear-gradient(90deg, rgba(6, 31, 44, 0.50), rgba(6, 31, 44, 0.24)), url("/assets/wp-original/nelore-banner-capa1-scaled.jpg"); transform: scale(1.02); }
  33%, 63% { background-image: linear-gradient(90deg, rgba(6, 31, 44, 0.50), rgba(6, 31, 44, 0.24)), url("/assets/wp-original/nelore-banner-capa2-scaled.jpg"); transform: scale(1.08); }
  66%, 100% { background-image: linear-gradient(90deg, rgba(6, 31, 44, 0.50), rgba(6, 31, 44, 0.24)), url("/assets/wp-original/nelore-banner-capa3-scaled.jpg"); transform: scale(1.12); }
}

h1,
h2,
h3,
p {
  margin-top: 0;
}

h1 {
  margin-bottom: 18px;
  font-size: 4.3rem;
  line-height: 1;
}

.hero p {
  max-width: 520px;
  margin-bottom: 28px;
  font-size: 1rem;
  color: #ffffff;
}

.button {
  min-height: 42px;
  padding: 0 24px;
}

.categoryCards {
  width: min(1200px, calc(100% - 80px));
  min-height: 250px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin: -110px auto 90px;
  position: relative;
  z-index: 2;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 28px 55px rgba(13, 40, 54, 0.18);
}

.categoryCards article {
  padding: 42px 34px;
  text-align: center;
  border-right: 1px solid #e7edf0;
}

.categoryCards article:last-child {
  border-right: 0;
}

.categoryCards .active {
  background: #123b55;
  color: #ffffff;
}

.categoryCards span {
  width: 56px;
  height: 56px;
  display: inline-grid;
  place-items: center;
  margin-bottom: 18px;
  border-radius: 50%;
  background: #123b55;
  color: #ffffff;
  font-size: 1.6rem;
}

.categoryCards .active span {
  background: #ffffff;
  color: #123b55;
}

.categoryCards h2 {
  margin-bottom: 8px;
  font-size: 1.05rem;
}

.categoryCards p {
  color: #6d7c84;
  font-size: 0.9rem;
}

.categoryCards .active p {
  color: #d9e3e8;
}

.production {
  width: min(1200px, calc(100% - 80px));
  display: grid;
  grid-template-columns: 1fr 1.1fr;
  gap: 68px;
  align-items: center;
  margin: 0 auto 92px;
}

.production h2 {
  max-width: 520px;
  margin-bottom: 24px;
  font-size: 2.55rem;
  line-height: 1.05;
}

.production p {
  color: #5b6c76;
}

.specialList {
  margin-top: 36px;
  display: grid;
  max-width: 390px;
}

.specialList strong {
  margin-bottom: 14px;
}

.specialList span {
  border-bottom: 1px solid #e3eaee;
  padding: 12px 0;
  color: #59707b;
  font-size: 0.9rem;
}

.ctaBand {
  min-height: 315px;
  display: grid;
  place-items: center;
  background-image: linear-gradient(rgba(8, 38, 55, 0.50), rgba(8, 38, 55, 0.50)), url("/assets/wp-original/nelore-comendo.jpg");
  background-position: top center;
  background-size: cover;
  color: #ffffff;
  text-align: center;
}

.ctaBand h2 {
  max-width: 520px;
  margin-bottom: 24px;
  font-size: 3.35rem;
  line-height: 1;
}

.emptyWordpressGap {
  display: none;
}

.trustBand {
  width: min(1200px, calc(100% - 80px));
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(320px, 1.1fr);
  gap: 64px;
  align-items: center;
  margin: 92px auto 38px;
}

.trustBand h2,
.homeNews h2 {
  margin-bottom: 18px;
  font-size: 2.55rem;
  line-height: 1.05;
}

.trustBand p {
  color: #5b6c76;
}

.trustBand img {
  width: 100%;
  filter: drop-shadow(0 24px 34px rgba(13, 40, 54, 0.16));
}

.sectionLabel {
  margin: 0 0 10px;
  color: #ec1236;
  font-size: 0.78rem;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.catalogGridSection,
.homeNews {
  padding: 86px max(56px, calc((100vw - 1200px) / 2));
}

.catalogGridSection {
  padding-top: 8px;
  background: #f7fafb;
}

.catalogGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  margin-top: 34px;
}

.catalogGrid a {
  overflow: hidden;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 48px rgba(8, 39, 55, 0.10);
}

.catalogGrid img {
  width: 100%;
  aspect-ratio: 16 / 10;
  object-fit: cover;
}

.catalogGrid strong,
.catalogGrid p {
  display: block;
  margin-left: 22px;
  margin-right: 22px;
}

.catalogGrid strong {
  margin-top: 20px;
  color: #123b55;
  font-size: 1.05rem;
}

.catalogGrid p {
  margin-bottom: 22px;
  color: #5b6c76;
}

footer {
  background: #0b3447;
  color: #ffffff;
  padding: 100px max(72px, calc((100vw - 1200px) / 2)) 28px;
}

.footerInner {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr 0.9fr 1.1fr;
  gap: 72px;
  margin-bottom: 82px;
}

footer h3 {
  margin-bottom: 18px;
  font-size: 1.15rem;
}

footer p,
footer a {
  color: #d8e4e9;
  font-size: 0.9rem;
}

footer a {
  display: block;
  border-bottom: 1px solid rgba(255, 255, 255, 0.14);
  padding: 8px 0;
}

.socials {
  display: flex;
  gap: 10px;
  margin-top: 24px;
}

.socials span {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.16);
}

footer input {
  width: 100%;
  height: 36px;
  border: 0;
  border-radius: 999px;
  padding: 0 16px;
  font: inherit;
}

footer button {
  width: 100%;
  height: 38px;
  margin-top: 10px;
}

.copyright {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.14);
  padding-top: 24px;
  color: #d8e4e9;
  font-size: 0.78rem;
}

.pageHero {
  min-height: 335px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 12px;
  padding: 64px 24px;
  background: linear-gradient(rgba(8, 38, 55, 0.52), rgba(8, 38, 55, 0.52)), url("/assets/bovinos.jpg");
  background-size: cover;
  background-position: center;
  color: #ffffff;
  text-align: center;
}

.pageHero h1 {
  margin: 0;
}

.pageHero h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}

.internalPage {
  padding: 90px max(56px, calc((100vw - 1200px) / 2));
}

.internalPage p {
  color: #5b6c76;
}

.internalCards {
  position: static;
  margin: 42px 0 72px;
  width: 100%;
  grid-template-columns: repeat(5, 1fr);
}

.productSections {
  display: grid;
  gap: 30px;
  padding-top: 18px;
}

.productSections article {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 28px;
  align-items: center;
  border-bottom: 1px solid #e3eaee;
  padding: 0 0 30px;
}

.productSections img {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: 8px;
}

.productSections h2 {
  min-height: 0;
  margin-bottom: 12px;
  color: #123b55;
}

.productSections ul {
  margin: 18px 0 20px;
  padding-left: 18px;
  color: #5b6c76;
}

.aboutPage {
  min-height: 2440px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 460px;
  gap: 64px;
  align-items: start;
}

.aboutPage img {
  width: 100%;
}

.missionBox {
  grid-column: 1 / -1;
  margin-top: 36px;
  padding: 48px;
  background: #f4f8fa;
}

.commitmentPage {
  min-height: 1220px;
  display: grid;
  grid-template-columns: 430px minmax(0, 1fr);
  gap: 66px;
  align-items: center;
}

.commitmentPage img {
  width: 100%;
  min-height: 420px;
  object-fit: cover;
}

.newsPage {
  min-height: 950px;
}

.newsGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
  margin: 28px 0 72px;
}

.newsCard {
  display: block;
  overflow: hidden;
  border: 1px solid #e3eaee;
  border-radius: 8px;
  background: #ffffff;
}

.newsCard img {
  width: 100%;
  aspect-ratio: 16 / 10;
  object-fit: cover;
}

.newsCard h3,
.newsCard span {
  display: block;
  margin: 20px 22px;
}

.newsCard span {
  color: #ec1236;
  font-size: 0.78rem;
  font-weight: 800;
}

.contactPage {
  min-height: 1160px;
  display: grid;
  grid-template-columns: 0.85fr 1.15fr;
  gap: 70px;
}

.contactPage form {
  display: grid;
  gap: 14px;
}

.contactPage input,
.contactPage textarea,
.commentBox textarea {
  width: 100%;
  border: 1px solid #dde8ee;
  border-radius: 8px;
  padding: 15px 16px;
  font: inherit;
}

.contactPage textarea,
.commentBox textarea {
  min-height: 170px;
  resize: vertical;
}

.articlePage {
  width: min(930px, calc(100% - 80px));
  min-height: 2650px;
  margin: 0 auto;
  padding: 90px 0 110px;
}

.articlePage h6 {
  margin: 0 0 14px;
  color: #ec1236;
  font-size: 0.82rem;
  text-transform: uppercase;
}

.articlePage time {
  display: block;
  margin-bottom: 34px;
  color: #5b6c76;
  font-size: 0.84rem;
}

.articlePage > img {
  width: 100%;
  max-height: 680px;
  object-fit: cover;
  margin-bottom: 38px;
}

.articlePage p {
  color: #5b6c76;
  font-size: 1rem;
}

.commentBox {
  margin-top: 70px;
  padding-top: 40px;
  border-top: 1px solid #dde8ee;
}

.catalogCta {
  margin-top: 54px;
  padding: 38px;
  background: #f4f8fa;
}

@media (max-width: 860px) {
  .topLine {
    display: none;
  }

  .navBar {
    height: auto;
    width: calc(100% - 32px);
    flex-direction: column;
    align-items: flex-start;
    padding: 20px 0;
  }

  nav {
    width: 100%;
    overflow-x: auto;
    gap: 18px;
    padding-top: 16px;
    white-space: nowrap;
  }

  .hero {
    min-height: 430px;
    padding: 48px 24px;
  }

  h1 {
    font-size: 3rem;
  }

  .categoryCards,
  .production,
  .trustBand,
  .catalogGrid,
  .productSections article,
  .footerInner,
  .aboutPage,
  .commitmentPage,
  .newsGrid,
  .contactPage {
    grid-template-columns: 1fr;
  }

  .categoryCards {
    width: calc(100% - 32px);
    margin-top: -40px;
  }

  .production {
    width: calc(100% - 32px);
  }

  .internalPage {
    padding-left: 24px;
    padding-right: 24px;
  }

  .aboutPage {
    min-height: 2920px;
  }

  .commitmentPage {
    min-height: 1420px;
  }

  .contactPage {
    min-height: 1470px;
  }

  .articlePage {
    width: calc(100% - 32px);
    min-height: 3180px;
  }

  .emptyWordpressGap {
    display: none;
  }

  .trustBand {
    width: calc(100% - 32px);
    margin: 62px auto 24px;
    gap: 28px;
  }

  .catalogGridSection,
  .homeNews {
    padding: 64px 24px;
  }

  footer {
    padding: 70px 24px 28px;
  }

  .copyright {
    flex-direction: column;
  }
}
